import { defineStore } from 'pinia'
import type { Supplier } from '@/types/supplier-types'
import { getSupplierById } from '@/api/suppliers'
import { qualityList } from '@/constants/suppliers'

export const useSupplierStore = defineStore('supplier', {
  state: () => ({
    supplierPricings: [] as any[],
    knitingFields: [] as any[],
    finishingFields: [] as any[],
    testingFields: [] as any[],
    qualityCheckFields: [] as any[],
  }),
  actions: {
    addPricingToField(pricing: any, qualityList: any[], fieldArray: any[]) {

      fieldArray.push({
        id: pricing.id,
        quality: pricing.qualityId,
        priceType: pricing.priceType,
        costPerUnitCurrency: pricing.costPerUnitCurrency,
        costPerUnitAmount: pricing.costPerUnitAmount,
        startDate: new Date(pricing.startDate),
        endDate: pricing.endDate ? new Date(pricing.endDate) : null,
        isActive: pricing.isActive,
        hasBeenUsed: pricing.hasBeenUsed,
        canBeDeleted: pricing.canBeDeleted
      })
    },
    resetFields() {
      this.knitingFields.length = 0
      this.finishingFields.length = 0
      this.testingFields.length = 0
      this.qualityCheckFields.length = 0
    },
    async categorizeSupplierPricing(supplierId: string) {
      this.resetFields()
      const supplier: Supplier = await getSupplierById(supplierId)
      this.supplierPricings = supplier.supplierPricings

      this.supplierPricings.map((pricing) => {
        switch (pricing.pricingType) {
          case 0:
            this.addPricingToField(pricing, qualityList, this.knitingFields)
            break
          case 1:
            this.addPricingToField(pricing, qualityList, this.finishingFields)
            break
          case 2:
            this.addPricingToField(pricing, qualityList, this.testingFields)
            break
          case 3:
            this.addPricingToField(pricing, qualityList, this.qualityCheckFields)
            break
          default:
            console.warn(`Unexpected pricingType: ${pricing.pricingType}`)
        }
      })
    }
  }
})
